import React from 'react';
import T from 'prop-types';
// components
import { Droppable, Draggable } from 'react-beautiful-dnd';
// utils
import classnames from 'classnames/bind';
// styles
import styles from './BarnSheetsManageColumns.module.scss';

const cn = classnames.bind(styles);

const ColumnsDropZone = ({ droppableId, fields, isEmpty, placeholder, label, matchSearch }) => (
  <Droppable droppableId={droppableId}>
    {(provided, snapshot) => (
      <div
        ref={provided.innerRef}
        {...provided.droppableProps}
        className={cn('drop-zone', {
          'is-dragging-over': snapshot.isDraggingOver,
          'is-empty': isEmpty,
        })}
      >
        {fields.map((column, index) => (
          <Draggable key={column.id} draggableId={column.id} index={index}>
            {(draggableProvided, draggableSnapshot) => (
              <div
                className={cn('visible-field', {
                  'is-dragging': draggableSnapshot.isDragging,
                  'is-not-matching-search': !matchSearch(column),
                })}
                ref={draggableProvided.innerRef}
                {...draggableProvided.draggableProps}
                {...draggableProvided.dragHandleProps}
              >
                <i className={cn('fa fa-dots-three-vertical', 'drag-icon')} />
                {column.label}
                <span className={cn('field-status')}>{label}</span>
              </div>
            )}
          </Draggable>
        ))}
        {isEmpty && <div className={cn('placeholder')}>{placeholder}</div>}
        {!isEmpty && provided.placeholder}
      </div>
    )}
  </Droppable>
);

ColumnsDropZone.propTypes = {
  droppableId: T.string.isRequired,
  fields: T.array.isRequired,
  isEmpty: T.bool.isRequired,
  placeholder: T.node,
  label: T.node,
  matchSearch: T.func.isRequired,
};

export default ColumnsDropZone;
